import {
  FETCH_CERTIFICATES_ATTEMPT,
  FETCH_CERTIFICATES_SUCCESS,
  FETCH_CERTIFICATES_ERROR,
  FETCH_CERTIFICATES_RESET_STATE,
  DELETE_CERTIFICATE_ATTEMPT,
  DELETE_CERTIFICATE_SUCCESS,
  DELETE_CERTIFICATE_ERROR,
  DELETE_CERTIFICATE_RESET_STATE,
} from "../actionTypes/actionTypes";

const initialState = {
  certificates: {
    data: [],
    perPage: 10,
    page: 1,
    total: 0,
    attempt: false,
    success: false,
    error: null,
  },
  deleteCertificate: {
    attempt: false,
    success: false,
    error: null,
  },
};

const certificatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CERTIFICATES_ATTEMPT:
      return {
        ...state,
        certificates: {
          ...state.certificates,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_CERTIFICATES_SUCCESS:
      return {
        ...state,
        certificates: {
          ...action.payload,
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_CERTIFICATES_ERROR:
      return {
        ...state,
        certificates: {
          ...state.certificates,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case FETCH_CERTIFICATES_RESET_STATE:
      return {
        ...state,
        certificates: {
          ...state.certificates,
          attempt: false,
          success: false,
          error: null,
        },
      };
    case DELETE_CERTIFICATE_ATTEMPT:
      return {
        ...state,
        deleteCertificate: {
          attempt: true,
          success: false,
          error: null,
        },
      };
    case DELETE_CERTIFICATE_SUCCESS:
      return {
        ...state,
        deleteCertificate: {
          attempt: false,
          success: true,
          error: null,
        },
        certificates: {
          ...state.certificates,
          data: state.certificates.data.filter(
            (cert) => cert.id !== action.payload.id
          ),
          total: state.certificates.total - 1,
        },
      };
    case DELETE_CERTIFICATE_ERROR:
      return {
        ...state,
        deleteCertificate: {
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case DELETE_CERTIFICATE_RESET_STATE:
      return {
        ...state,
        deleteCertificate: {
          attempt: false,
          success: false,
          error: null,
        },
      };
    default:
      return state;
  }
};

export default certificatesReducer;

